import Api from '../api/Api';
import resolve from  '../util/Configuracao';

class DemonstrativoApi extends Api {
  async consultarDemonstrativos () {
    try {
      const urlConsultarDemonstrativos = resolve('urlConsultarDemonstrativos');
      const response = await this.fetch(urlConsultarDemonstrativos);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async getPrestadoresComDp () {
    try {
      const urlConsultarPrestadoresComDp = resolve('urlConsultarPrestadoresComDp');
      const response = await this.fetch(urlConsultarPrestadoresComDp);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }  
  async getEstadosDp () {
    try {
      const urlConsultarEstadosDp = resolve('urlConsultarEstadosDp');
      const response = await this.fetch(urlConsultarEstadosDp);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }  
  async consultarDemonstrativosPorFiltro (numDemonstrativo, seqPrestador, codFatura, tipoDp, aguardandoNf, pendentePagto, emissaoFrom, emissaoTo, 
    pagtoFrom, pagtoTo, codEstado, notaFiscal, numLote) {
    let demonstrativos = [];
    const brancoAcoes = '';
    let tipoBotaoCancelamento = '';
    try {
      const urlConsultarDemonstrativosPorFiltro = resolve('urlConsultarDemonstrativosPorFiltro') + 
      numDemonstrativo + '/' + 
      seqPrestador + '/' + 
      codFatura  + '/' + 
      tipoDp + '/' + 
      aguardandoNf + '/' + 
      pendentePagto + '/' + 
      emissaoFrom + '/' + 
      emissaoTo + '/' + 
      pagtoFrom + '/' + 
      pagtoTo + '/' + 
      codEstado + '/' + 
      notaFiscal + '/' + 
      numLote
      ;
      const { data } = await this.fetch(urlConsultarDemonstrativosPorFiltro);
      data.map(res => {
        const { numDemonstrativoPag, dtaEmissao, dtaPagamento, strDtaPagamentoNotaUniao, strDtaPagamentoNotaPlano, codPrestador, nomPrestador, cnpjPrestador, valTotalProcessado, valTotalGlosado, valTotalLiberado, dtaCancelamento, dtaCienciaRecurso, dtaFimRecurso, valTotalLiquido, indCancelado, valTotalBruto, valTotalUniao, valTotalPlano, valTotalPago, valRestaPagar, strDtaPagamento, strDtaEmissao, strDtaCienciaRecurso, strDtaFimRecurso, txtObservacao, indOdontologico, indReapresentacao, numNotaFiscalUniao, numNotaFiscalPlano, codBanco, codAgencia, txtContaCorrente, strDtaEmissaoNotaUniao, strDtaAtesteNotaUniao, strDtaEmissaoNotaPlano, strDtaAtesteNotaPlano, strDtaCancelamento, nomUsuarioCancelamento, txtMotivoCancelamento, historicos, codEstadoAtualDemonstrativo, desEstadoAtualDemonstrativo, valTotalEfetivamentePago, ateste, indAtesteComissao } = res;

        if (indCancelado === 'S') {
          tipoBotaoCancelamento = 'DESFAZER';
        } else {
          if (dtaPagamento === null) {
            tipoBotaoCancelamento = 'CANCELAR';
          } else {
            tipoBotaoCancelamento = 'NENHUM';
          }
        }
                
        demonstrativos.push(Object.values({ numDemonstrativoPag, dtaEmissao, dtaPagamento, strDtaPagamentoNotaUniao, strDtaPagamentoNotaPlano, cnpjPrestador, codPrestador, nomPrestador, valTotalLiquido, valTotalProcessado, valTotalGlosado, valTotalLiberado, valTotalBruto, dtaCancelamento, dtaCienciaRecurso, dtaFimRecurso, indCancelado, valTotalUniao, valTotalPlano, valTotalPago, valRestaPagar, tipoBotaoCancelamento, brancoAcoes, strDtaPagamento, strDtaEmissao, strDtaCienciaRecurso, strDtaFimRecurso, txtObservacao, indOdontologico, indReapresentacao, numNotaFiscalUniao, numNotaFiscalPlano, codBanco, codAgencia, txtContaCorrente, strDtaEmissaoNotaUniao, strDtaAtesteNotaUniao, strDtaEmissaoNotaPlano, strDtaAtesteNotaPlano, strDtaCancelamento, nomUsuarioCancelamento, txtMotivoCancelamento, codEstadoAtualDemonstrativo, desEstadoAtualDemonstrativo, valTotalEfetivamentePago, historicos, ateste, indAtesteComissao }));
      });
      return demonstrativos;
    } catch (error) {
      console.error(error);
    }
  }

  async getFaturasDp (numDemonstrativo) {
    let faturas = [];
    const brancoAcoes = '';
    try {
      const urlConsultarFaturasDp = resolve('urlConsultarFaturasDp') + numDemonstrativo;
      const { data } = await this.fetch(urlConsultarFaturasDp);
      data.map(res => {
        const { codFatura, numeroFatura, numLote, dtaRecebimento, numProtocolo, valorProcessado, valorLiberado, valorGlosado, valorLiberadoDependenteEspecial, indReapresentacao } = res;
        faturas.push(Object.values({ codFatura, numeroFatura, numLote, dtaRecebimento, numProtocolo, valorProcessado, valorLiberado, valorGlosado, valorLiberadoDependenteEspecial, indReapresentacao, brancoAcoes }));
      });
      return faturas;
     } catch (error) {
      console.error(error);
    }
  }
  async getFaturasDpRaw (numDemonstrativo) {
    try {
      const urlConsultarFaturasDp = resolve('urlConsultarFaturasDp') + numDemonstrativo;
      const { data } = await this.fetch(urlConsultarFaturasDp);
      return data;
     } catch (error) {
      console.error(error);
    }
  }
  async getFaturasDpOdontoRaw (numDemonstrativo) {
    try {
      const urlConsultarFaturasOdontoDp = resolve('urlConsultarFaturasOdontoDp') + numDemonstrativo;
      const { data } = await this.fetch(urlConsultarFaturasOdontoDp);
      return data;
     } catch (error) {
      console.error(error);
    }
  }
  async getCreditosDebitosManuaisDp (numDemonstrativo) {
    let creditosDebitosManuais = [];
    const brancoAcoes = '';
    try {
      const urlConsultarCreditosDebitosManuaisDp = resolve('urlConsultarCreditosDebitosManuaisDp') + numDemonstrativo;
      const { data } = await this.fetch(urlConsultarCreditosDebitosManuaisDp);
      data.map(res => {
        const { desCreditoDevolucao, valCreditoDevolucao, origemRecursoDevolucao, indManual } = res;
        creditosDebitosManuais.push(Object.values({ desCreditoDevolucao, valCreditoDevolucao, origemRecursoDevolucao, indManual, brancoAcoes }));
      });
      return creditosDebitosManuais;
     } catch (error) {
      console.error(error);
    }
  }

  async consultarDemonstrativosNaoPagos (numDemonstrativo) {
    try {
      const urlConsultarDemonstrativosNaoPagos = resolve('urlConsultarDemonstrativosNaoPagos') + numDemonstrativo;
      const response = await this.fetch(urlConsultarDemonstrativosNaoPagos);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async alterarDemonstrativo (demonstrativo) {
    try {
      const urlAlterarDemonstrativo = resolve('urlAlterarDemonstrativo');
      await this.fetch(urlAlterarDemonstrativo, 'put', demonstrativo);
    } catch (error) {
      console.error(error);
    }
  }
  async impressaoDemonstrativo (numDemonstrativo) {
    try {
      const urlImpressaoDemonstrativo = resolve('urlImpressaoDemonstrativo') + numDemonstrativo;
      const response = await this.fetch(urlImpressaoDemonstrativo);
      return response.data;
    } catch (error) {      
      console.error(error);      
      return 'Erro na impressão do DP';
    }
  }  
  async montarGrafico (filter) {
    try {
      const urlConsultarGrafico = resolve('urlConsultarGrafico') + filter.ano + '/tipo/' + filter.tipo;
      const response = await this.fetch(urlConsultarGrafico);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async incluirDemonstrativo (demonstrativo) {
    try {
      const urlIncluirDemonstrativo = resolve('urlIncluirDemonstrativo');
      const response = await this.fetch(urlIncluirDemonstrativo, 'post', demonstrativo);
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async excluirDemonstrativo (numDemonstrativo) {
    try {
      const urlExcluirDemonstrativo = resolve('urlExcluirDemonstrativo') + numDemonstrativo;
      const response = await this.fetch(urlExcluirDemonstrativo, 'post');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async atestarDocumentosDemonstrativo (numDemonstrativo) {
    try {
      const urlAtestarDocumentosDemonstrativo = resolve('urlAtestarDocumentosDemonstrativo') + numDemonstrativo;
      const response = await this.fetch(urlAtestarDocumentosDemonstrativo, 'post');
      return response;
    } catch (error) {
      console.error(error);
    }
  }  
  async desfazerAtesteDocumentosDemonstrativo (numDemonstrativo) {
    try {
      const urlDesfazerAtesteDocumentosDemonstrativo = resolve('urlDesfazerAtesteDocumentosDemonstrativo') + numDemonstrativo;
      const response = await this.fetch(urlDesfazerAtesteDocumentosDemonstrativo, 'post');
      return response;
    } catch (error) {
      console.error(error);
    }
  }    
  async cancelarDemonstrativo (numDemonstrativo, motivoCancelamento) {
    try {
      const urlCancelarDemonstrativo = resolve('urlCancelarDemonstrativo') + numDemonstrativo + '/' + motivoCancelamento;
      const response = await this.fetch(urlCancelarDemonstrativo, 'post');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async desfazerCancelamentoDemonstrativo (numDemonstrativo) {
    try {
      const urlDesfazerCancelamentoDemonstrativo = resolve('urlDesfazerCancelamentoDemonstrativo') + numDemonstrativo;
      const response = await this.fetch(urlDesfazerCancelamentoDemonstrativo, 'post');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async trocarOrigemPagamento (numDemonstrativo, valUniao, valPlano, valTotalLiberado) {
    try {
      const urlTrocarOrigemPagamentoDemonstrativo = resolve('urlTrocarOrigemPagamentoDemonstrativo') + numDemonstrativo + '/' + valUniao + '/' + valPlano + '/' + valTotalLiberado;
      const response = await this.fetch(urlTrocarOrigemPagamentoDemonstrativo, 'post');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async liberarParaPagamento (numDemonstrativo, origemPagamento, numNota, dtaEmissao, dtaAteste) {
    try {
      const urlLiberarDemonstrativoParaPagamento = resolve('urlLiberarDemonstrativoParaPagamento') + numDemonstrativo + '/' + origemPagamento + '/' + numNota + '/' + dtaEmissao + '/' + dtaAteste;
      const response = await this.fetch(urlLiberarDemonstrativoParaPagamento, 'post');
      return response;
    } catch (error) {
      console.error(error);
    }
  }

  async atualizarDadosPagamento (numDemonstrativo) {
    try {
      const urlAtualizarDadosPagamento = resolve('urlAtualizarDadosPagamento') + numDemonstrativo;
      const response = await this.fetch(urlAtualizarDadosPagamento, 'post');
      return response;
    } catch (error) {
      console.error(error);
    }
  }    
  async consultarArquivos (numDemonstrativo) {
    let arquivos = [];
    try {
      const urlConsultarArquivosDemonstrativo = resolve('urlConsultarArquivosDemonstrativo') + numDemonstrativo;
      const { data } = await this.fetch(urlConsultarArquivosDemonstrativo);
      data.map(res => {
        const { numDemonstrativo, cnpjOrigemPagamento, nomeOrigemPagamento, codTipoArquivo, desTipoArquivo, nomeArquivo, txtObjetoGed, indExcluir, indUpload, codArquivoGed } = res;
        arquivos.push(Object.values({ numDemonstrativo, cnpjOrigemPagamento, nomeOrigemPagamento, codTipoArquivo, desTipoArquivo, nomeArquivo, txtObjetoGed, indExcluir, indUpload, codArquivoGed }));
      });
      return arquivos;
    } catch (error) {
      console.error(error);
    }
  }  
  async anexarArquivo (numDemonstrativo, nomeArquivo, txtObjetoGed, tipoArquivo, cnpjOrigemPagamento) {
    try {
      const urlAnexarArquivoDemonstrativo = resolve('urlAnexarArquivoDemonstrativo') + numDemonstrativo + '/' + nomeArquivo + '/' + txtObjetoGed + '/' + tipoArquivo + '/' + cnpjOrigemPagamento;
      const response = await this.fetch(urlAnexarArquivoDemonstrativo, 'put');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async deletarArquivo (codArquivoGed) {
    try {
      const urlDeletarArquivoDemonstrativo = resolve('urlDeletarArquivoDemonstrativo') + codArquivoGed;
      const response = await this.fetch(urlDeletarArquivoDemonstrativo, 'put');
      return response;
    } catch (error) {
      console.error(error);
    }
  }  

  async processarArquivoBenner () {
    try {
      const urlProcessarArquivoBenner = resolve('urlProcessarArquivoBenner');
      const response = await this.fetch(urlProcessarArquivoBenner);
      return response;
    } catch (error) {
      console.error(error);
    }
  }  
  async consultarArquivosBenner (nomArquivo, from, to) {
    let arquivos = [];
    const brancoAcoes = '';
    try {
      const urlConsultarArquivosBenner = resolve('urlConsultarArquivosBenner') + nomArquivo + '/' + from + '/' + to;
      const { data } = await this.fetch(urlConsultarArquivosBenner);
      data.map(res => {
        const { codArquivo, nomeArquivo, txtObjetoGed, dtaImportacao, indValido } = res;
        arquivos.push(Object.values({ codArquivo, nomeArquivo, txtObjetoGed, dtaImportacao, indValido, brancoAcoes}));
      });
      return arquivos;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarDetalhesArquivo (codArquivo) {
    let detalhes = [];
    try {
      const urlConsultarDetalhesArquivoBenner = resolve('urlConsultarDetalhesArquivoBenner') + codArquivo;
      const { data } = await this.fetch(urlConsultarDetalhesArquivoBenner);
      data.map(res => {
        const { codArquivo, numeroDemonstrativoPagamento, codOB, numOB, numeroCnpjOrigem, cnpjPrestador, nomePrestador, numNotaFiscal, dtaEmissaoNotaFiscal, dataLiquidacaoOB, codEventoOB, desEventoOB, valorBruto } = res;
          detalhes.push(Object.values({codArquivo, numeroDemonstrativoPagamento, codOB, numOB, numeroCnpjOrigem, cnpjPrestador, nomePrestador, numNotaFiscal, dtaEmissaoNotaFiscal, dataLiquidacaoOB, codEventoOB, desEventoOB, valorBruto}));
      });
      return detalhes;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarUsuariosAssinantes (codUsuariosSelecionados) {
    let usuarios = [];
    let brancoAcoes = '';
    const urlUsuariosAssinantes = resolve('urlUsuariosAssinantes'); 
    const { data } = await this.fetch(urlUsuariosAssinantes, 'post', codUsuariosSelecionados);
    data.map(res => {
      const { codUsuarioAssinante, numCpf, nomUsuario } = res;
      usuarios.push(Object.values({ codUsuarioAssinante, numCpf, nomUsuario, brancoAcoes }));
    });
    return usuarios;
  }
  async consultarAssinantesDoAteste (codAteste) {
    let usuarios = [];
    let brancoAcoes = '';
    const urlConsultarAssinantes = resolve('urlConsultarAssinantes') + codAteste; 
    const { data } = await this.fetch(urlConsultarAssinantes);
    data.map(res => {
      const { codAtesteAssinante, codAteste, codUsuarioAssinante, indAssinado, dtaAssinatura, nomUsuario, numCpf } = res;
      usuarios.push(Object.values({ codAtesteAssinante, codAteste, codUsuarioAssinante, numCpf, nomUsuario, indAssinado, dtaAssinatura, brancoAcoes, brancoAcoes }));
   });
    return usuarios;
  }

  async incluirAteste (ateste) {
    try {
      const urlIncluirAteste = resolve('urlIncluirAteste');
      const response = await this.fetch(urlIncluirAteste, 'post', ateste);
      return response;
    } catch (error) {
      console.error(error);
    }
  }  
  async alterarAteste (ateste, estadoAtualDp) {
    try {
      const urlAlterarAteste = resolve('urlAlterarAteste') + '/' + estadoAtualDp;
      const response = await this.fetch(urlAlterarAteste, 'post', ateste);
      return response;
    } catch (error) {
      console.error(error);
    }
  }  
  async assinarAteste (codAssinante, numDemonstrativo, codAteste) {
    try {
      const urlAssinarAteste = resolve('urlAssinarAteste') + codAssinante + '/' + numDemonstrativo + '/' + codAteste;
      const response = await this.fetch(urlAssinarAteste, 'put');
      return response;
    } catch (error) {
      console.error(error);
    }
  }  
  async assinarAtestesDoUsuario (numDemonstrativo, codUsuario) {
    try {
      const urlAssinarAtestesUsuario = resolve('urlAssinarAtestesUsuario') + numDemonstrativo + '/' + codUsuario;
      const response = await this.fetch(urlAssinarAtestesUsuario, 'put');
      return response;
    } catch (error) {
      console.error(error);
    }
  }  
  async getEstadoAtualDp (numDemonstrativo) {
    const urlEstadoAtualDp = resolve('urlEstadoAtualDp') + numDemonstrativo; 
    const estadoAtual = await this.fetch(urlEstadoAtualDp);
    return estadoAtual;
  }
}

export default DemonstrativoApi;
